export default __webpack_public_path__ + "static/media/TodayHabits.873e0e05.png";